import { WorkspaceTopicList, type WorkspaceTopicSelectArgs } from "./WorkspaceTopicList";

type WorkspaceTopicRailProps = {
  enabled: boolean;
  workspaceId: string;
  workspaceName: string;
  canCreateTopics?: boolean;
  selectedTopicKey?: { workspaceId: string; topicId: string } | null;
  onSelectTopic?: (args: WorkspaceTopicSelectArgs) => void;
  topicsRefreshEpoch?: number;
  currentUserId?: string;
  workspaceRole?: "owner" | "admin" | "member";
  onPinnedTopicIdsChange?: (workspaceId: string, ids: string[]) => void;
};

export function WorkspaceTopicRail({
  enabled,
  workspaceId,
  workspaceName,
  canCreateTopics,
  selectedTopicKey,
  onSelectTopic,
  topicsRefreshEpoch,
  currentUserId,
  workspaceRole = "member",
  onPinnedTopicIdsChange,
}: WorkspaceTopicRailProps) {
  if (!enabled || !workspaceId) return null;

  return (
    <aside className="topic-rail" aria-label="Topics">
      <div className="topic-rail__head">
        <span className="topic-rail__title" title="// Topics">
          // Topics
        </span>
        <span className="topic-rail__workspace" title={workspaceName}>
          {workspaceName}
        </span>
      </div>
      <div className="topic-rail__body">
        <WorkspaceTopicList
          key={workspaceId}
          enabled={enabled}
          workspaceId={workspaceId}
          workspaceName={workspaceName}
          canCreateTopics={canCreateTopics}
          selectedTopicKey={selectedTopicKey}
          onSelectTopic={onSelectTopic}
          topicsRefreshEpoch={topicsRefreshEpoch}
          currentUserId={currentUserId}
          workspaceRole={workspaceRole}
          onPinnedTopicIdsChange={onPinnedTopicIdsChange}
        />
      </div>
    </aside>
  );
}
